<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10tIdgi/tc-custom/9781504057684.jpg?1726519407687" alt="This image is the cover for the book Miss Silver Mysteries Volume Six, The Miss Silver Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Miss Silver Mysteries Volume Six, The Miss Silver Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Three mysteries featuring governess-turned-sleuth Miss Silver, who “has her place in detective fiction as surely as Lord Peter Wimsey or Hercule Poirot” (<i>Manchester Evening News</i>).</b><br/><br/> Retired governess Maud Silver is about as unlikely a sleuth that Scotland Yard has ever seen—but her unassuming manner only helps her unravel their most mystifying cases in “some of the best examples of the British country-house murder mystery” (<i>Alfred Hitchcock’s Mystery Magazine</i>).<br/>  <br/><i>Miss Silver Comes to Stay</i>: While visiting an old school chum in the rustic town of Melling, Miss Silver soon finds that its bucolic charm hides undercurrents of murderous vengeance. When Melling’s prodigal son returns with a lot of money and a long-held grudge against the town, he intends to sell his manor house and be done with Melling forever. But this cozy English hamlet isn’t finished with him . . . and it may be about to finish him off.<br/>  <br/><i>Mr. Brading’s Collection</i>: Jewel collector Lewis Brading leaves little to chance, housing his gems in a concrete annex protected by the latest security system and his own watchful eye. But he still suspects something might be wrong. He consults Maud Silver, who tells him to send his collection to a museum as soon as possible. Ignoring her advice may be the last mistake Brading ever makes . . .<br/>  <br/><i>The Ivory Dagger</i>: Bill Waring had a promising career and the love of a young beauty—until a freak train accident puts him in the hospital for a month. When he gets out, he is stunned to learn that his beloved has become engaged to another. Determined to win her back, Bill follows her and her charmless new fiancé on a weekend in the country. When her new betrothed is stabbed to death, blame falls squarely on Bill—and only the brilliant, demure Maud Silver can clear his name.<br/>  <br/> These charming British mysteries featuring the unstoppable Miss Silver—whose stout figure, fondness for Tennyson, and passion for knitting belie a keen intellect and a knack for cracking even the toughest cases—are sure to delight readers of Agatha Christie, Ellis Peters, and Dorothy L. Sayers.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia  Wentworth
      </h2>
      
      <p class="authorDescription body article">Patricia Wentworth (1878&ndash;1961) was one of the masters of classic English mystery writing. Born in India as Dora Amy Elles, she began writing after the death of her first husband, publishing her first novel in 1910. In the 1920s, she introduced the character who would make her famous: Miss Maud Silver, the former governess whose stout figure, fondness for Tennyson, and passion for knitting served to disguise a keen intellect. Along with Agatha Christie&rsquo;s Miss Marple, Miss Silver is the definitive embodiment of the English style of cozy mysteries.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?426f4074